import { render, staticRenderFns } from "./CaseCytologyQuestions.vue?vue&type=template&id=055a9826&scoped=true&"
import script from "./CaseCytologyQuestions.vue?vue&type=script&lang=js&"
export * from "./CaseCytologyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CaseCytologyQuestions.vue?vue&type=style&index=0&id=055a9826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a9826",
  null
  
)

export default component.exports